<ng-template #exportHistorymodal let-modal>
    <div class="offcanvas-header border-bottom">
        <h4 class="modal-title">{{ "heading-title.export-history" | translate }}</h4>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>

    <div class="offcanvas-body">
        <div class="row">
            <div class="col-12">
                <div class="table-responsive">
                    <table aria-describedby="disc" class="table table-hover mb-0 tableScroll">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    {{ "label-title.create-time" | translate }}
                                </th>

                                <th scope="col">
                                    {{ "label-title.action" | translate }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (history of exportHistoryList; track $index) {
                            <tr>
                                <td class="text-nowrap">
                                    @if (history.createdAt) {
                                    <span>{{
                                        helper.moment(history.createdAt).tz(helper.displayTimezone).format(helper.DATE_FORMAT.DD_MM_YY)
                                        }} -
                                        {{
                                        helper.moment(history.createdAt).tz(helper.displayTimezone).format(helper.getTimeFormat(null))
                                        }}</span>
                                    } @else {
                                    <span>--</span>
                                    }
                                </td>
                                @if (history.status == helper.ExportHistoryStatusEnum.QUEUE) {
                                <td>
                                    <span class="badge bg-warning">{{ "label-title.processing" | translate }}</span>
                                </td>
                                } @if (history.status == helper.ExportHistoryStatusEnum.FAILED) {
                                <td>
                                    <span class="badge bg-danger">{{ "label-title.failed" | translate }}</span>
                                </td>
                                } @if (history.status == helper.ExportHistoryStatusEnum.COMPLETED) {
                                <td>
                                    <div class="d-flex gap-1">
                                        <button type="button" class="btn btn-soft-success btn-sm text-nowrap mr-1"
                                            (click)="helper.downloadFile(history.uri)">
                                            {{ "button-title.download" | translate }}
                                        </button>
                                        <button type="button" class="btn btn-soft-danger btn-sm text-nowrap"
                                            (click)="openDeleteModal(history._id)">
                                            {{ "button-title.delete" | translate }}
                                        </button>
                                    </div>
                                </td>
                                }
                            </tr>
                            } @empty {
                            <tr>
                                <th colspan="12" class="text-center" id="export-history-no-records-found">
                                    <span>{{ "label-title.no-records-found" | translate }}</span>
                                </th>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<app-delete-modal #deleteOpenModal (deleteDataEvent)="deleteExportHistory($event)"></app-delete-modal>